import React from 'react';
import CountUp from 'react-countup';
import { Skeleton } from '@mui/material';
import { isMobile } from "react-device-detect";

const TotalSavingsCard = props => {

    const metricFontSize = isMobile ? "4vh" : "6vh";

    return(
        <div style={{height:'100%', width:'100%', padding: isMobile ? "4%" : '1% 2%', backgroundColor:'white', boxShadow:'2px 6px 12px rgb(164, 164, 164)'}}>
            <h3 style={{textAlign: 'center', marginBottom: isMobile ? "3%" : "1%"}}>{props.utility}</h3>

            <div style={{ display: "flex", flexDirection: isMobile ? "column" : "row", justifyContent: "space-around", alignItems: "center", gap: isMobile ? "2vh" : "0"}}>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                    {
                    props.isLoading 
                    ? <Skeleton style={{ height: isMobile ? "4vh" : "5vh", width: "120px" }} />
                    : <>
                        <span className="metric-span m-0">
                            <CountUp separator="," style={{ color: "rgb(0,177,168)", fontSize: metricFontSize, margin: "0" }} end={props.metrics[0]} duration={1}/> {"kg"}
                        </span>
                        <span>of total CO<sub>2e</sub> saved</span>
                        </>
                    }
                </div>

            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                {
                props.isLoading 
                ? <Skeleton style={{ height: isMobile ? "4vh" : "5vh", width: "120px" }} />
                : <>
                    <span className="metric-span m-0">
                        <CountUp prefix="$" separator="," style={{ color: "rgb(77, 79, 83)", fontSize: metricFontSize, margin: "0" }} end={props.metrics[1]} duration={1}/>
                    </span>
                    <span>in total financial savings</span>
                    </>
                }
            </div>
            
        </div>
        <br/>
        </div>
    )
}

export default TotalSavingsCard;